import { useMemo } from 'react';

export const useTimeRange = (events: any[]) => {
	const timeRange = useMemo(() => {
		const sortedEvents = events
			.slice()
			.sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime());
		const earliestTime = new Date(sortedEvents[0].startTime);
		const latestTime = Math.max(...sortedEvents.map(event => new Date(event.startTime).getTime()));

		const dateLatestTime: Date = new Date(latestTime);

		//Adding one hours before earliest event and two hours after last event two give spacing
		earliestTime.setHours(earliestTime.getHours());
		dateLatestTime.setHours(dateLatestTime.getHours() + 2);

		return {
			earliestTime,
			latestTime: dateLatestTime,
		};
	}, [events]);

	return timeRange;
};

export const useEventsByLocation = (events: any[]) => {
	const eventsByLocation = useMemo(() => {
		const locationEventsMap: Map<string, any[]> = new Map();
		for (const event of events) {
			const location = event.location ? event.location.name : 'ukendt';
			if (!locationEventsMap.has(location)) {
				locationEventsMap.set(location, []);
			}
			locationEventsMap.get(location)?.push(event);
		}

		const locationEventsArray = Array.from(locationEventsMap.entries()).map(([location, events]) => ({
			location,
			events,
		}));

		const locationOrder = ['Bøgescenerne', 'Stjernescenen', 'Månen', 'The Hood', 'Udsigten'];
		locationEventsArray.sort((a, b) => {
			const aIndex = locationOrder.indexOf(a.location);
			const bIndex = locationOrder.indexOf(b.location);
			if (aIndex === -1 && bIndex === -1) {
				return a.location.localeCompare(b.location);
			}
			if (aIndex === -1) {
				return 1;
			}
			if (bIndex === -1) {
				return -1;
			}
			return aIndex - bIndex;
		});

		return locationEventsArray;
	}, [events]);

	return eventsByLocation;
};
